const state = {
  mailingContactColumnList: [],
};

const mutations = {
  SET_MAILING_CONTACT_COLUMN_LIST(state, columnList) {
    state.mailingContactColumnList = columnList;
  },
  ADD_MAILING_CONTACT_COLUMN(state, column) {
    state.mailingContactColumnList.push(column);
  },
  CLEAR_MAILING_CONTACT_COLUMN_LIST(state) {
    state.mailingContactColumnList = [];
  },
};

const actions = {
  setMailingContactColumnList({ commit }, columnList) {
    commit('SET_MAILING_CONTACT_COLUMN_LIST', columnList);
  },
  addMailingContactColumn({ commit }, column) {
    commit('ADD_MAILING_CONTACT_COLUMN', column);
  },
  clearMailingContactColumnList({ commit }) {
    commit('CLEAR_MAILING_CONTACT_COLUMN_LIST');
  },
};

const getters = {
  mailingContactColumnList: (state) => state.mailingContactColumnList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
